export const locKeys = {
  a11yPriceLockupLabel: "merchCampaign.price.lockup.a11yLabel",
  priceDisclaimerLabel: "merchCampaign.disclaimerIcon.title",
};
